import { Routes } from '@angular/router';
import { PROMO_BASE_PATH, PROMO_LANDING_PAGE } from './promo.config';

export function promoRoutes(): Routes {
  return [
    {
      path: PROMO_BASE_PATH,
      loadComponent: () =>
        import('./promo-landing.component').then((m) => m.PromoLandingComponent),
      runGuardsAndResolvers: 'paramsChange',
      data: {
        landing: true,
        promo: true,
        landingPage: PROMO_LANDING_PAGE,
        page: {
          seo: PROMO_LANDING_PAGE.seo,
        },
      },
    },
    {
      path: `${PROMO_BASE_PATH}/:code`,
      loadComponent: () =>
        import('./promo-landing.component').then((m) => m.PromoLandingComponent),
      runGuardsAndResolvers: 'paramsChange',
      data: {
        landing: true,
        promo: true,
        landingPage: PROMO_LANDING_PAGE,
        page: {
          seo: PROMO_LANDING_PAGE.seo,
        },
      },
    },
  ];
}
